import React from 'react';

import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import { Link, Typography } from '@material-ui/core';

import { Skeleton } from '@material-ui/lab';

import HomeWorkIcon from '@material-ui/icons/HomeWork';

class AuthorityCard extends React.Component {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        areaInfo: PropTypes.object
    };

    constructor (props) {
        super(props);
    }

    render () {
        const { classes, areaInfo } = this.props;

        const isLoading = !Boolean(areaInfo);

        if (isLoading) { return <Skeleton animation="wave" height={86} variant="rect" />; }

        return (
            <div className={classes.authorityContainer}>
                <div className={classes.logoContainer}>
                    <HomeWorkIcon className={classes.logo} />
                </div>
                {/* <img className={classes.logo} src={areaInfo.authorityLogo} alt={areaInfo.authorityName}/> */}
                <div>
                    <Typography variant="subtitle1">
                        Local Authority
                    </Typography>
                    <Typography variant="body1">
                        {areaInfo.authorityName || 'N/A'}
                    </Typography>
                    <div>
                        {
                            areaInfo.ldpPdfUrl && <Link
                                href={areaInfo.ldpPdfUrl}
                                target="_blank"
                                underline="none"
                                variant="caption"
                            >
                                View local development plan
                            </Link>
                        }
                        &nbsp;•&nbsp;
                        {
                            areaInfo.ldpSiteUrl && <Link
                                href={areaInfo.ldpSiteUrl}
                                target="_blank"
                                underline="none"
                                variant="caption"
                            >
                                View local plan status
                            </Link>
                        }
                    </div>
                </div>
            </div>
        );
    }
}

const style = theme => ({
    authorityContainer: {
        display: 'flex',
        alignItems: 'center',
        border: `1px solid ${theme.palette.background.border}`,
        borderRadius: '5px',
        position: 'relative',
        color: theme.palette.text.primary,
        fontWeight: 500,
        fontSize: '11px',
        padding: '15px'
    },
    logo: {
        width: 50,
        height: 50,
        minWidth: 50,
        minHeight: 50,
        backgroundColor: theme.palette.secondary.light,
        borderRadius: 5,
        boxSizing: 'border-box',
        padding: 10,
        marginRight: 15
    }
});

export default withStyles(style)(AuthorityCard);